// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__21mvN","content":"Consent_content__2aeMD","footer":"Consent_footer__2bx6Q"};